import TextareaAutosize from 'react-textarea-autosize';
import styled, { css } from 'styled-components';

export const ChatContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
`;

export const ChatContent = styled.div`
	flex: 1 1 auto;
	overflow: hidden;
	position: relative;
	width: 100%;
`;

export const ChatMessages = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 101%;
	width: 100%;
	overflow-x: auto;
	padding: 4px;

	color: rgba(255, 255, 255, 0.5);

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background-color: #f1f1f1;
		border-radius: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #aaaaaa;
		border-radius: 10px;
	}
`;

export const ChatMessageBox = styled.div`
	${({ theme }) => css`
		flex: 0 1 40px;
		width: 100%;
		padding: 20px;
		position: relative;
		border: solid 1px ${theme.colors.neutral[200]};
		border-radius: 5px;
		margin-top: 18px;
	`}
`;

export const ChatMessageForm = styled.form`
	display: flex;
`;

export const ChatMessageInput = styled(TextareaAutosize)`
	${({ theme }) => css`
		background: none;
		border: none;
		outline: none;
		resize: none;
		font-size: 15px;
		height: 21px;
		margin: 0;
		padding-right: 20px;
		width: 265px;
		overflow: hidden;

		&::placeholder {
			color: ${theme.colors.neutral[400]};
		}

		&::focus:-webkit-placeholder {
			color: transparent;
		}
	`};
`;

export const ChatMessageSubmit = styled.button`
	position: absolute;
	background-color: transparent;
	z-index: 1;
	top: 50%;
	transform: translateY(-50%);
	right: 10px;
	color: #fff;
	border: none;
	font-size: 10px;
	text-transform: uppercase;
	line-height: 1;
	padding: 6px 10px;
	border-radius: 10px;
	outline: none !important;
	transition: background 0.2s ease;
`;

export const ChatEmptyContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-items: center;
	text-align: center;
	padding: 0 42px;
	height: 100%;
`;

export const ChatEmptyTitle = styled.div`
	${({ theme }) => css`
		font-size: ${theme.fontSizes.default};
		font-weight: ${theme.fontWeights.bold};
		
		text-align: center;
	`};
`;

export const ChatEmptyDescription = styled.div`
	${({ theme }) => css`
		font-size: ${theme.fontSizes.default};
		color: ${theme.colors.neutral[400]};
	`};
`;
